import React, { useEffect, useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import { useForm, useFormState } from 'react-final-form';

export const CustomerFromMobile: React.FC = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const form = useForm();
  const [summary, setSummary] = useState<string>('');
  const { values } = useFormState({ subscription: { values: true } });
  const mobile: string | undefined = (values as any)?.customerMobile;

  // useEffect(() => {
  //   // On initial load of edit screen, customerMobile may be undefined while customerId is already set.
  //   // In that case, do NOT clear customerId; just wait until user types something.
  //   if (mobile === undefined || mobile === null) {
  //     return;
  //   }
  //   debugger
  //   const trimmed = mobile.trim();

  //   // If user clears or types an invalid-length mobile, clear derived customer info.
  //   if (trimmed.length !== 10) {
  //     setSummary('');
  //     form.change('customerId', undefined);
  //     form.change('isNewCustomerFromMobile', false);
  //     // clear any new-customer fields when mobile is empty/short/invalid
  //     form.change('newCustomerName', undefined);
  //     form.change('newCustomerCode', undefined);
  //     form.change('newCustomerState', undefined);
  //     form.change('newCustomerAddress1', undefined);
  //     form.change('newCustomerAddress2', undefined);
  //     form.change('newCustomerAddress3', undefined);
  //     form.change('newCustomerPincode', undefined);
  //     return;
  //   }

  //   let cancelled = false;

  //   const lookup = async () => {
  //     try {
  //       const res: any = await dataProvider.getList('customers', {
  //         pagination: { page: 1, perPage: 1 },
  //         sort: { field: 'id', order: 'DESC' },
  //         // use exact mobile match so existing numbers are reliably found
  //         filter: { 
  //           //mobileNo: mobile,
  //           userId: localStorage.getItem('userId')
  //         },
  //       });

  //       if (cancelled) return;

  //       if (res.data && res.data.length > 0) {
          
  //         const c = res.data[0];
  //         form.change('customerId', c.id);
  //         form.change('isNewCustomerFromMobile', false);
  //         // existing customer: clear any new-customer fields
  //         form.change('newCustomerName', undefined);
  //         form.change('newCustomerCode', undefined);
  //         form.change('newCustomerState', undefined);
  //         form.change('newCustomerAddress1', undefined);
  //         form.change('newCustomerAddress2', undefined);
  //         form.change('newCustomerAddress3', undefined);
  //         form.change('newCustomerPincode', undefined);
  //         const addr = [c.address1, c.address2, c.address3, c.city, c.state]
  //           .filter((x: any) => x && String(x).trim())
  //           .join(', ');
  //         setSummary(`${c.customerName || ''}${addr ? ' - ' + addr : ''}`);
  //       } else {
  //         form.change('customerId', undefined);
  //         form.change('isNewCustomerFromMobile', false);
  //         setSummary("");
  //       }
  //     } catch (e) {
  //       if (cancelled) return;
  //       console.error('Error looking up customer by mobile', e);
  //       notify('Error looking up customer by mobile', { type: 'warning' });
  //     }
  //   };

  //   lookup();

  //   return () => {
  //     cancelled = true;
  //   };
  // }, [ dataProvider, form, notify]);
useEffect(() => {
  let cancelled = false;

  const lookup = async () => {
    try {
      const isCustLogin =
        localStorage.getItem("type") === "isCustLogin";

      let res: any;

      // Customer Login
      if (isCustLogin) {
        res = await dataProvider.getList("customers", {
          pagination: { page: 1, perPage: 1 },
          sort: { field: "id", order: "DESC" },
          filter: {
            userId: localStorage.getItem("userId"),
          },
        });
      } 
      // Admin Login
      else {
        if (!mobile || mobile.trim().length !== 10) {
          setSummary("");
          form.change("customerId", undefined);
          form.change("isNewCustomerFromMobile", false);

          form.change("newCustomerName", undefined);
          form.change("newCustomerCode", undefined);
          form.change("newCustomerState", undefined);
          form.change("newCustomerAddress1", undefined);
          form.change("newCustomerAddress2", undefined);
          form.change("newCustomerAddress3", undefined);
          form.change("newCustomerPincode", undefined);

          return;
        }

        res = await dataProvider.getList("customers", {
          pagination: { page: 1, perPage: 1 },
          sort: { field: "id", order: "DESC" },
          filter: {
            mobileNo: mobile,
          },
        });
      }

      if (cancelled) return;

      if (res.data && res.data.length > 0) {
        const c = res.data[0];

        // IMPORTANT
        form.change("customerId", c.id);
        form.change("customerMobile", c.mobileNo);
        form.change("isNewCustomerFromMobile", false);

        form.change("newCustomerName", undefined);
        form.change("newCustomerCode", undefined);
        form.change("newCustomerState", undefined);
        form.change("newCustomerAddress1", undefined);
        form.change("newCustomerAddress2", undefined);
        form.change("newCustomerAddress3", undefined);
        form.change("newCustomerPincode", undefined);

        const addr = [
          c.address1,
          c.address2,
          c.address3,
          c.city,
          c.state,
        ]
          .filter((x: any) => x && String(x).trim())
          .join(", ");

        setSummary(
          `${c.customerName || ""}${addr ? " - " + addr : ""}`
        );
      } else {
        form.change("customerId", undefined);
        form.change("isNewCustomerFromMobile", false);
        setSummary("");
      }
    } catch (e) {
      if (cancelled) return;
      console.error(e);
      notify("Error looking up customer", {
        type: "warning",
      });
    }
  };

  lookup();

  return () => {
    cancelled = true;
  };
}, [mobile, dataProvider, form, notify]);

  return (
    <div style={{ marginTop: 8, fontSize: 13, color: '#444' }}>
      {summary}
    </div>
  );
};
